export default __webpack_public_path__ + "static/media/predator.67296137.ttf";